export const SUPPORTED_LOCALES_MAP = {
  english: 'en',
  frenchCanadian: 'fr-CA',
} as const;
export const SUPPORTED_LOCALES = Object.values(SUPPORTED_LOCALES_MAP);
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE = SUPPORTED_LOCALES_MAP.english;

export const isLocaleSupported = (locale: string): locale is SupportedLocale =>
  SUPPORTED_LOCALES.includes(locale as SupportedLocale);

/** true = 12-hour. Adding a locale is a type error until a convention is set. */
export const LOCALE_HOUR12: Record<SupportedLocale, boolean> = {
  en: true,
  'fr-CA': false,
};

/** Unknown locales inherit English. */
export const hour12ForLocale = (locale: string): boolean => {
  if (isLocaleSupported(locale)) {
    return LOCALE_HOUR12[locale];
  }
  return LOCALE_HOUR12[DEFAULT_LOCALE];
};
